const ValuationSourceEnum = Object.freeze({
    FUND_MANAGER: 'FUND_MANAGER',
    COMPANIES_HOUSE: 'COMPANIES_HOUSE',
    GAZETTE: 'GAZETTE',
    GROWTHINVEST: 'GROWTHINVEST',
    MORNINGSTAR: 'MORNINGSTAR'
});

export default ValuationSourceEnum;
